import { eventBus, VERIFIED_CONNECTION_MILESTONES } from "@kubera/common";

import { ANALYTICS } from "analytics";
import { TrackAnalytics } from "utilities/TrackAnalytics";

export const TrackVerifiedConnectionsInit = () => {
  eventBus.addEventListener("any", event => {
    const { eventName, data } = event.detail;

    if (eventName !== "verifiedConnectionMilestone") {
      return;
    }

    const milestone = data[0];
    if (VERIFIED_CONNECTION_MILESTONES.includes(milestone) === false) {
      return;
    }

    TrackAnalytics({
      category: ANALYTICS.CATEGORY.USER,
      action: `${ANALYTICS.ACTION.VERIFIED_CONNECTED}_${milestone}`
    });
  });
};
